module.exports = __webpack_public_path__ + "static/media/tjt_mtm.9fbd97f2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/agsm/img/tjt_mtm.png
 ** module id = 1666
 ** module chunks = 0
 **/